/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamDropdown_teams = ReadonlyArray<{
    readonly node: {
        readonly name: string | null;
        readonly id: string;
    } | null;
    readonly " $refType": "TeamDropdown_teams";
}>;
export type TeamDropdown_teams$data = TeamDropdown_teams;
export type TeamDropdown_teams$key = ReadonlyArray<{
    readonly " $data"?: TeamDropdown_teams$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamDropdown_teams">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamDropdown_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamTypeEdge"
};
(node as any).hash = 'dcc9577bdda4ff58599704d28a66776f';
export default node;
